import { useState, useEffect } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import {
  FileDoneOutlined,
  PlayCircleOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Button } from "antd";

function Tasks() {
  const [tasks, setTasks] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "http://78.186.196.90:8091/Task/GetAll?TeacherId=" + user.id
      );
      setTasks(response.data.value);
    };
    fetchData();
  }, []);
  console.log("tasks:::::", tasks);

  const handleNew = () => {
    window.location.href = "http://78.186.196.90:8181/Tasks/0";
  };
  return (
    <main>
      <header className="flex-row">
        <div>
          <h1>Tasks</h1>
          <p>
            In this screen, a scenario is assigned as an assignment to a class
            previously created by the instructor. In the assignment screen,
            class and scenario selection is required.
          </p>
        </div>
        {user.role === "teacher" && (
          <Button type="primary" onClick={handleNew}>
            New
          </Button>
        )}
      </header>
      <section className="scenarios">
        <div className="wrapper">
          <div className="cards">
            {tasks.map((item) => {
              return (
                <NavLink
                  className="card"
                  to={`http://78.186.196.90:8181/tasks/${item.id}`}
                  key={item.id}
                >
                  <FileDoneOutlined className="icon" />
                  <div className="card-body">
                    <p className="card-title">{item.title}</p>
                    <p className="card-desc">{item.scenarioName}</p>
                  </div>
                </NavLink>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Tasks;
